import classNames from "classnames";
import React from "react";
import { BUTTON_SIZE } from "../consts";
import styles from "../statics/styles/button-scss";
const Button = ({
  onClick,
  dataHook,
  ariaLabel,
  size = BUTTON_SIZE.small,
  children,
  tabIndex = 0,
  disabled = false,
  secondary = false,
  borderless = false,
  isMobile = false,
  style
}) => {
  const buttonStyle = secondary ? styles.button_secondary : styles.button_primary;
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      "aria-label": ariaLabel,
      "data-hook": dataHook,
      onClick,
      tabIndex,
      disabled,
      className: classNames(buttonStyle, styles[size], {
        [styles.borderLess]: borderless,
        [styles.mobile]: isMobile
      }),
      style,
      type: "button"
    },
    children
  );
};
var Button_default = Button;
export {
  Button_default as default
};
//# sourceMappingURL=Button.js.map
